<template>
    <div id="m_quick_sidebar" class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light" :class="{ 'm-quick-sidebar--on': detailOffer }">
        <div class="m-quick-sidebar__content" v-if="detailOffer">

            <div class="tab-header">
                <h3><span v-if="detailOffer.firma != ''">{{ detailOffer.firma }}</span><span v-else>{{ detailOffer.name }}</span> - {{ detailOffer.name }}</h3>
            </div>
            <span id="m_quick_sidebar_close" class="m-quick-sidebar__close" @click="closeDetail()"><i class="la la-close"></i></span>
            <ul id="m_quick_sidebar_tabs" class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand" role="tablist">
                <li class="nav-item m-tabs__item">
                    <a class="nav-link m-tabs__link active" data-toggle="tab" href="#m_quick_sidebar_tabs_messenger" role="tab">Nachrichten</a>
                </li>
                <li class="nav-item m-tabs__item">
                    <a class="nav-link m-tabs__link" data-toggle="tab" href="#m_quick_sidebar_tabs_settings" role="tab">Anfrage</a>
                </li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane active" id="m_quick_sidebar_tabs_messenger" role="tabpanel">
                    <div class="m-messenger m-messenger--message-arrow m-messenger--skin-light">
                        <div class="m-messenger__messages m-scrollable m-scroller ps ps--active-y">
                            <div v-for="update in detailOffer.updates" class="m-messenger__wrapper">

                                <div v-if="update.type == 'Kunden Feedback'" class="m-messenger__message m-messenger__message--out">
                                    <div class="m-messenger__message-body">
                                        <div class="m-messenger__message-arrow"></div>
                                        <div class="m-messenger__message-content">
                                            <div class="m-messenger__message-username">
                                                <span v-if="update.user != update.for_user && update.for_user != '-'"><b>{{ update.type }} - {{ update.for_user }}</b> von {{ update.user }} am {{ update.created_at }}</span>
                                                <span v-else><b>{{ update.type }} - {{ update.user }}</b> am {{ update.created_at }}</span>
                                            </div>
                                            <div class="m-messenger__message-text" v-html="update.text"></div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="update.type == 'Projekt Information'" class="m-messenger__message m-messenger__message--warning">
                                    <div class="m-messenger__message-pic">
                                        <img :src="'img/user-' + update.user + '.jpg'" alt="">
                                    </div>
                                    <div class="m-messenger__message-body">
                                        <div class="m-messenger__message-arrow"></div>
                                        <div class="m-messenger__message-content">
                                            <div class="m-messenger__message-username">
                                                <span v-if="update.user != update.for_user && update.for_user != '-'"><b>{{ update.type }} - {{ update.for_user }}</b> von {{ update.user }} am {{ update.created_at }}</span>
                                                <span v-else><b>{{ update.type }} - {{ update.user }}</b> am {{ update.created_at }}</span>
                                            </div>
                                            <div class="m-messenger__message-text" v-html="update.text"></div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="m-messenger__message m-messenger__message--in">
                                    <div class="m-messenger__message-pic">
                                        <img :src="'img/user-' + update.user + '.jpg'" alt="">
                                    </div>
                                    <div class="m-messenger__message-body">
                                        <div class="m-messenger__message-arrow"></div>
                                        <div class="m-messenger__message-content">
                                            <div class="m-messenger__message-username">
                                                <span v-if="update.user != update.for_user && update.for_user != '-'"><b>{{ update.type }} - {{ update.for_user }} für den {{ update.reminder }}</b> von {{ update.user }} am {{ update.created_at }}</span>
                                                <span v-else><b>{{ update.type }} - {{ update.user }}</b> am {{ update.created_at }} für den {{ update.reminder }}</span>
                                            </div>
                                            <div class="m-messenger__message-text" v-html="update.text"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="m-messenger__datetime" style="clear:both;"></div>
                        <div class="m-messenger__seperator"></div>
                        <div class="m-messenger__form d-block">
                            <div class="m-messenger__form-controls d-block">
                                <div class="form-group m-form__group row">
                                    <label for="example-date-input" class="col-12 col-form-label">Typ</label>
                                    <select class="col-12 form-control m-input m-input--square" id="timetrackArr" v-model="reminderType">
                                        <option v-for="(type, key) in reminderTypeArr" :value="key">{{ type }}</option>
                                    </select>
                                </div>
                                <div v-if="reminderType == 1 || reminderType == 2" class="form-group m-form__group row">
                                    <label for="example-date-input" class="col-12 col-form-label">Reminder für</label>
                                    <select class="col-12 form-control m-input m-input--square" id="usersArr" v-model="reminderManagerId">
                                        <option v-for="manager in managers" :value="manager.id">{{ manager.name }}</option>
                                    </select>
                                </div>
                                <div v-if="reminderType == 1 || reminderType == 2" class="form-group m-form__group row">
                                    <label for="example-date-input" class="col-12 col-form-label">Reminder</label>
                                    <input class="form-control m-input col-12" type="date" v-model="reminderDate" id="example-date-input">
                                </div>
                                <div class="form-group m-form__group row">
                                    <label class="col-12" for="note">Nachricht</label>
                                    <textarea id="note" class="col-12 form-control m-input" rows="3" v-model="reminderText"></textarea>
                                </div>
                                <div class="form-group m-form__group row">
                                    <button class="btn btn-brand" @click="saveReminder()">Speichern</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane" id="m_quick_sidebar_tabs_settings" role="tabpanel">
                    <div class="m-list-settings m-scrollable m-scroller ps" style="height: 968px; overflow: hidden;">
                        <div class="m-list-settings__group">
                            <div class="m-list-settings__heading mb-1">Kunde</div>
                            <div class="m-list-settings__item p-0">
                                <div class="m-card-user m-card-user--sm">
                                    <div class="m-card-user__pic">
                                        <div class="m-card-user__no-photo m--bg-fill-success" :class="'m-badge--client-class-' + detailOffer.classId"><span>{{ detailOffer.className }}</span></div>
                                    </div>
                                    <div class="m-card-user__details">
                                        <span class="m-card-user__name m--font-primary" v-if="detailOffer.firma != ''" style="max-width:350px;">{{ detailOffer.firma }}</span>
                                        <span class="m-card-user__name" style="max-width:350px;">{{ detailOffer.name }}</span>
                                        <span class="m-card-user__name" style="max-width:350px;"><small><i class="fa fa-at"></i> {{ detailOffer.email }}</small></span>
                                        <span class="m-card-user__name" v-if="detailOffer.telefon != ''" style="white-space: nowrap"><small><i class="fa fa-phone"></i> {{ detailOffer.telefon }}</small></span>
                                        <span class="m-card-user__name" v-if="detailOffer.client_id != 0" style="white-space: nowrap"><small><i class="fa fa-user"></i> Kundennummer: {{ detailOffer.client_id }}</small></span>
                                        <span class="m-card-user__name" v-else-if="detailOffer.client_id != 0" style="white-space: nowrap"><small><i class="fa fa-user"></i> NEUKUNDE</small></span>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div class="m-list-settings__heading mt-5 mb-1">Anfrage</div>
                            <table class="table">
                                <tbody>
                                <tr>
                                    <th>Kategorie</th>
                                    <th>{{ detailOffer.categoryName }}</th>
                                </tr>
                                <tr>
                                    <td>Produkttyp</td>
                                    <td>{{ detailOffer.produkttyp }}</td>
                                </tr>
                                <tr>
                                    <td>Produkt</td>
                                    <td>{{ detailOffer.price }}</td>
                                </tr>
                                <tr>
                                    <th>Anzahl</th>
                                    <th>{{ detailOffer.anzahlCa }}</th>
                                </tr>
                                </tbody>
                            </table>
                            <h6>Anfrage Text:</h6>
                            <p class="mt-3">{{ detailOffer.anfrage }}</p>
                        </div>
                        <hr />
                        <div class="m-list-settings__group">
                            <div class="m-list-settings__heading">Angebot</div>
                            <table class="table">
                                <tbody>
                                <tr>
                                    <td>Kalenderwoche</td>
                                    <td>{{ detailOffer.kw }}</td>
                                </tr>
                                <tr>
                                    <td>Geplante Arbeitsstunden</td>
                                    <td>{{ detailOffer.working_hours }} Stunden</td>
                                </tr>
                                <tr>
                                    <td>Preis pro {{ detailOffer.unit }}</td>
                                    <td>{{ detailOffer.price }}€</td>
                                </tr>
                                <tr>
                                    <th>Gesamtbetrag</th>
                                    <th>{{ detailOffer.sum }}</th>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'client-single',
    props: {
        detailOffer: [Boolean, Object],
        user: Object,
        reminderTypeArr: Array,
        managers: Array,
    },
    data() {
        return {
            reminderDate: "",
            reminderText: "",
            reminderType: 1,
            reminderManagerId: this.user.id,
        }
    },
    methods:{
        showDetails(offer){
            this.detailOffer = offer;
        },

        closeDetail(){
            this.detailOffer = null;
        },
        saveReminder(){
            if (this.detailOffer){
                $.ajax({
                    url :'/save-inquiry-note-' + this.detailOffer.id,
                    type: "POST",
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    data: { reminderType: this.reminderType, reminderText: this.reminderText, reminderDate: this.reminderDate, reminderManagerId: this.reminderManagerId },
                    success:  (data) => {
                        if (this.reminderType == 1 || this.reminderType == 2 || this.reminderType == 5 || this.reminderType == 8){
                            location.reload();
                        }
                        else if (this.reminderType == 3){
                            this.detailOffer.updates.push({
                                "for_user": "",
                                "reminder": "",
                                "text": this.reminderText,
                                "type": "Reminder erledigt",
                                "type_id": "3",
                                "user": this.user.name,
                                "created_at": "today"
                            });
                        }
                        else if (this.reminderType == 4){
                            this.detailOffer.updates.push({
                                "for_user": "",
                                "reminder": "",
                                "text": this.reminderText,
                                "type": "Notiz",
                                "type_id": "4",
                                "user": this.user.name,
                                "created_at": "today"
                            });
                        }
                        else if (this.reminderType == 6){
                            this.detailOffer.updates.push({
                                "for_user": "",
                                "reminder": "",
                                "text": this.reminderText,
                                "type": "Kunden Feedback",
                                "type_id": "5",
                                "user": this.user.name,
                                "created_at": "today"
                            });
                        }
                        else if (this.reminderType == 7){
                            this.detailOffer.updates.push({
                                "for_user": "",
                                "reminder": "",
                                "text": this.reminderText,
                                "type": "Projekt Information",
                                "type_id": "7",
                                "user": this.user.name,
                                "created_at": "today"
                            });
                        }
                    },
                    error: function (jXHR, textStatus, errorThrown) {
                        console.log(errorThrown);
                    }

                });
            }
        }
    },
}
</script>
